import React from "react";
import { Link } from "react-router-dom";

const AboutSection = () => {
  return (
    <div className="space" id="about-sec">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6">
            <div className="img-box9">
              <img
                src="/assets/image/IMG-20250429-WA0004.jpg"
                alt="About"
                width={650}
                height={550}
              />

              <div
                className="about-counter1"
                data-bg-src="/assets/img/update1/bg/bg_pattern_3.png"
              >
                <h3 className="counter-title">
                  <span className="counter-number">16+</span>
                </h3>
                <span className="counter-text">Years Experience</span>
              </div>
            </div>
          </div>

          <div className="col-xl-6 ps-3 ps-xl-5">
            <div className="title-area mb-30">
              <span className="sub-title6">
                ABOUT US
                <span className="shape right">
                  <span className="dots"></span>
                </span>
              </span>
              <h2 className="sec-title">
                A Company That Cares for Clean Living.
              </h2>
            </div>
            <p className="mt-n2 mb-4">
              At Al Jurf Pest Control LLC, we are committed to protecting your
              home, business, and environment from unwanted pests. Based in
              Dubai, we are a licensed and trusted pest control company with
              years of experience in delivering safe, effective, and
              eco-friendly pest management solutions.
            </p>
            <div className="about-bg-shape">
              <div className="shape">
                <img src="/assets/img/update1/bg/bg_pattern_4.png" alt="bg" />
              </div>
              <div className="arrow-list-wrap">
                <div className="th-video">
                  <img
                    src="/assets/img/update1/normal/about_video_1.jpg"
                    alt="video"
                  />
                  <Link
                    to="https://www.youtube.com/watch?v=_sI_Ps7JSEk"
                    className="play-btn style2 popup-video"
                  >
                    <i className="fas fa-play"></i>
                  </Link>
                </div>
                <div className="arrow-list">
                  <ul>
                    <li>Licensed & Municipality-Approved</li>
                    <li>24/7 Availability & Emergency Response</li>
                    <li>High-Quality Pesticides & Advanced Technology</li>
                    <li>Confidential, Contract-Based Service</li>
                    <li>Reliable & Affordable</li>
                  </ul>
                </div>
              </div>
              <div className="signature-box-wrap">
                <Link to="/about" className="th-btn">
                  ABOUT MORE <i className="fas fa-arrow-right ms-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
